import type { ReactNode } from 'react';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import { TypographyVariant } from '../../utils/theme';
import TruncatedText from '../truncated-text';
import Typography from '../typography/typography';

export interface IInformationCard {
  title?: string | ReactNode;
  titleVariant?: TypographyVariant;
  children: ReactNode;
  headerActions?: ReactNode;
  as?: 'li' | 'div';
  gap?: number;
  truncateTitle?: boolean;
}

const InformationCard = ({
  title,
  titleVariant = TypographyVariant.h2,
  children,
  headerActions,
  as = 'div',
  gap = 3,
  truncateTitle = false,
}: IInformationCard) => {
  return (
    <Container data-testid="information-card" as={as} gap={gap}>
      {title && (
        <Header>
          {truncateTitle ? (
            <TruncatedTitleWrapper>
              <TruncatedText variant={titleVariant}>{title}</TruncatedText>
            </TruncatedTitleWrapper>
          ) : (
            <Typography variant={titleVariant}>{title}</Typography>
          )}
          {headerActions}
        </Header>
      )}
      {children}
    </Container>
  );
};

export default memo(InformationCard);

const Container = styled.div<{ gap: number }>`
  ${({ theme, gap }) => css`
    width: 100%;
    background-color: ${theme.palette.neutral['00']};
    border-radius: ${theme.borderRadius.sm};
    border: 1px solid ${theme.palette.neutral[60]};
    padding: ${theme.spacing(3)};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(gap)};
  `}
`;

const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing(3)};
  `}
`;

const TruncatedTitleWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-width: 0;
  `}
`;
